import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import type { IAPIArticleTeaser } from '@hokify/magazine-interface';
import ContentNavigationB2B from '~/components/website/ContentNavigationB2B.vue';
import Breadcrumbs from '~/components/website/Breadcrumbs.vue';
import { crumbsMaker } from '~/helpers/magazine';

const magazineStore = namespace('magazine');

@Component({
	components: {
		ItemList: () => import('~/components/website/list/ItemList.vue'),
		Breadcrumbs,
		ContentNavigationB2B,
		CallToAction: () => import('@hokify/shared-components/lib/components/CallToAction.vue')
	}
})
export default class MagazineBase extends Vue {
	@magazineStore.Action('loadArticlesForCategory') loadArticlesForCategory;

	@magazineStore.State('articleTeasers') articleTeasers;

	@magazineStore.Action('loadArticles') loadArticles;

	articlesPerApiCall = 10;

	crumbsMaker = crumbsMaker;

	hasCoreArticle(categoryArticles: IAPIArticleTeaser[]): boolean {
		return !!categoryArticles?.[0]?.isCoreArticle;
	}

	get upcomingEventsAscending(): IAPIArticleTeaser[] {
		return [...this.articleTeasers.upcomingevents].sort(
			(x, y) => new Date(x.date).getTime() - new Date(y.date).getTime()
		);
	}

	get partnersAscending(): IAPIArticleTeaser[] {
		return [...this.articleTeasers.partners].sort((x, y) =>
			x.title.toUpperCase().localeCompare(y.title.toUpperCase())
		);
	}
}
